import { render, staticRenderFns } from "./_sku.vue?vue&type=template&id=63bd0bde&"
import script from "./_sku.vue?vue&type=script&lang=js&"
export * from "./_sku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports